<template>
  <b-modal
    :id="'UploadImageAnswer' + componentKey"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-header
    hide-footer
    hide-backdrop
    size="lg"
    centered
    ref="ProductCroppa"
    @shown="onNewImage()">
    <div class="m-2 d-flex justify-content-between align-items-center" >
      <div class="modal-title pl-5">Edit Image</div>
      <div class="close-modal" @click="closeModal"> <img src="@/assets/images/close-x.svg" alt="Close Icon" width="13" height="13" /></div>
    </div>
    <div id="upload-images-range-container" :class="!isLoading ? 'border mx-auto' : 'border mx-auto  d-flex flex-column justify-content-between'" >
      <vueCropper
      v-if="!isLoading"
        ref="cropper"
        :img="cropperImage"
        :size="1"
        :full="false"
        :outputType="fileType"
        :canMove="false"
        :fixedBox="false"
        :original="false"
        :canMoveBox="true"
        :autoCrop="true"
        :autoCropWidth="setImageWidth"
        :autoCropHeight="setImageHeight"
        :centerBox="true"
        :max="99999"
        :show="true"
        :info="false"
        :fixed="false"
        :fixedNumber="[16, 9]"
        :canScale="false"
        @real-time="checkFile"
      ></vueCropper>
       <div class="mt-auto bg-primary text-center">
        <span v-if="isLoading" class="d-flex justify-content-center text-white">
          Rendering Image please wait ... <img class="spinner small mt-1 ml-2" src="@/assets/images/onboarding/loading.svg" alt="loading">
        </span>
      </div>
    </div>
    <template #modal-footer>
      <div class="d-flex align-items-center justify-content-between  mx-4 my-2">
        <div class="d-flex ">
          <div class="d-flex border border-gray rounded align-items-center pl-3 pr-4 pt-1 mr-2">
            <!-- slider div -->
            <img src="@/assets/images/image-icon-pan.svg" alt="Small Image Icon" width="20" height="20" class="pb-1 pr-2" />
            <div id="upload-image-answer-range-container">
              <input
                type="range"
                class="custom-range"
                id="customRange1"
                @input="onSliderChange"
                :min="sliderMin"
                :max="sliderMax"
                step=".01"
                v-model="sliderVal"
                :disabled="disableSlider"
                >         
            </div>
            <img src="@/assets/images/image-icon-pan.svg" alt="Small Image Icon" width="25" height="25" class="pb-1 pl-2" />
          </div>
          <div class="action-btn d-flex border border-gray rounded align-items-center px-1 mr-2" @click="checkDownloadFile()"><img src="@/assets/images/sim_card_download.svg" alt="Small Image Icon" width="20" height="13" /></div>
          <div class="action-btn d-flex border border-gray rounded align-items-center px-1 " style="margin-right: 3rem" @click="removeImage()"><img src="@/assets/images/dark-trash-can.svg" alt="Small Image Icon" width="20" height="13" /></div>
        </div>
        <b-button
            variant="primary"
            size="lg"
            class="w-100"
            style="border-radius: 2rem"
            @click="checkFileType">
            {{isCropping? 'Cropping... ':'Crop'}}
            <span v-if="isCropping"><img class="spinner small"
                                            src="@/assets/images/onboarding/loading.svg" alt="loading"></span>
          </b-button>
        <div> 
         
        </div>
      </div>
  
      
      </template>
  </b-modal>
</template>

<script>
import GIF from "gif.js";
import gifFrames from "gif-frames";

export default {
  name: "ProductCroppa",
  props: {
    values: {
      type: [Object, Array, String, Number, Boolean],
      default: null
    },
    initialValue: {
      type: String,
      default: ""
    },
    aspectRatio: {
      type: [Number,String],
      default: 1
    },
    fileName: {
      type: String,
      default: ""
    },
    imageKey: {
      type: [Number,String],
      default: ""
    },
    componentKey: {
      type: [Number,String],
      default: ""
    },
    fileType: {
      type: String,
      default: ""
    },
    rawImageFile: {
      type: [File,String],
      default: null
    },
    imageWidth: {
      type: [Number,String],
      default: 0
    },
    imageHeight: {
      type: [Number,String],
      default: 0
    }
  },
  data() {
  return {
    lastScale: 1, 
    sliderVal: 0,
    sliderMin: 0,
    sliderMax: 0,
    imageRawData: null,
    frames: [],
    encodedGif: null,
    isLoading: true,
    isCropping: false,
    setImageWidth: 500,
    setImageHeight: 400,
    currentImageHeight: 0,
    currentImageWidth: 0,
    isCloseOnly: true,
    setScale: 1,
    count:0,
    cropData: {},
    cropperImage: null,
    disableSlider: true,
    currentZoomValue: 1,
    originalFrames: []
  };
},
  methods: {
     async extractGifFrames(imageFile) {
      try {
        const url = URL.createObjectURL(imageFile);

        const frameData = await gifFrames({
          url,
          frames: "all",
          outputType: "canvas",
          cumulative: true,
        });

        const extractedFrames = frameData.map((frame) => {
          const delayMs = frame.frameInfo.delay * 10;
          const width = this.setImageWidth;
          const height = this.setImageHeight;

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");

          // Draw resized image on canvas
          ctx.drawImage(frame.getImage(), 0, 0, width, height);

          return {
            imageCanvas: canvas.toDataURL("image/png"),
            delay: delayMs,
            width,
            height,
          };
        });

        URL.revokeObjectURL(url);
        return extractedFrames;
      } catch (error) {
        console.error("Error extracting frames:", error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    createGif(frames, download) {
      const gif = new GIF({
        workers: 2,
        quality: 10,
        workerScript: '/worker/gif.worker.js',
        width: frames[0].width,
        height: frames[0].height
      });
      this.isLoading = true
      let loadedFrames = 0;
      frames.forEach((frame, index) => {
        const img = new Image();

        img.src = frame.imageCanvas;
        img.onload = () => {
          gif.addFrame(img, { delay: frame.delay });
          loadedFrames++;
          if (loadedFrames === this.frames.length) {
            gif.render();
          }
        };

        img.onerror = (error) => {
          
        };
      });

      gif.on("finished", (blob) => {
        this.encodedGif = URL.createObjectURL(blob);
        this.isLoading = false
        // Create a download link

        if (download === true) {
          const link = document.createElement("a");
          link.href = this.encodedGif;
             const extension = this.fileType === 'jpeg' ? '.jpg' :
          this.fileType === 'png' ? '.png' :
            this.fileType === 'gif' ? '.gif' : '.png';
          link.download = `${this.fileName}-cropped${extension}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.frames = this.originalFrames
        } else { 

          this.convertBlobUrlToBase64(this.encodedGif).then(data => {
            const prefix = data.match(/^data:image\/\w+;base64,/)[0]; // Extract prefix
            const base64String = data.replace(prefix, ""); // Remove prefix from data

          this.$emit("newImageData", {
            key: this.imageKey,
            prefix: prefix,
            base64: base64String,
            image: data,
            showImage: true
          });
          }).catch(error => {
          });
        }

      });

      gif.on("error", (error) => {
      });
    },
    convertBlobUrlToBase64(blobUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function() {
          const reader = new FileReader();
          reader.onloadend = function() {
            resolve(reader.result); 
          };
          reader.onerror = reject;
          reader.readAsDataURL(xhr.response);
        };
        xhr.onerror = reject;
        xhr.open('GET', blobUrl);
        xhr.responseType = 'blob';
        xhr.send();
        this.closeModal();
      });
    },
    checkSign(num) {
        const sign = Math.sign(num);
        return sign === -1 ? "negative" : sign === 1 ? "positive" : "zero";
    },
    cropBase64Image(base64, previewWidth, previewHeight, transform) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";

        img.onload = () => {
          // Extract the translation offsets from the transform string.
          const { scale,offsetX, offsetY } = this.getTransformValues(transform);
          // When an image is shifted using translate3d, the visible area in the preview
          // corresponds to a region in the image starting at (-offsetX, -offsetY).
          // For example, if offsetX is -20, then the crop should start at 20px on the x-axis.
          const cropX = (-offsetX)-(this.checkSign(offsetX) === 'negative' || this.checkSign(offsetX) === 'zero' ? 0: 65) /scale;
          const cropY = (-offsetY) - (this.checkSign(offsetY) === 'negative' || this.checkSign(offsetY) === 'zero' ? 0 : 65)  / scale;
          // Create a canvas with the dimensions of the preview area.
          const canvas = document.createElement('canvas');
          canvas.width = previewWidth;
          canvas.height = previewHeight;
          const ctx = canvas.getContext('2d');

          // Draw the appropriate region of the image onto the canvas.
          // If the image was moved with a negative offset, we start cropping at the positive value.
          ctx.drawImage(
            img,
            this.cropData.x/scale , this.cropData.y/scale ,           // Start cropping from here on the image.
            this.cropData.width/scale , this.cropData.height/scale, // Crop region size.
            0, 0,                   // Place the cropped image at the canvas origin.
            this.cropData.width/scale , this.cropData.height/scale  // Draw at the preview area dimensions.
          );
          

          // Convert the canvas back to a Base64 string.
          const croppedBase64 = canvas.toDataURL();
          resolve(croppedBase64);
        };

        img.onerror = (error) => reject(error);
        img.src = base64;
      });
    },
    getTransformValues(transformStr) {
      const regex = /scale\(([^)]+)\).*?translate3d\(\s*(-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\)/;
      const match = transformStr.match(regex);

      if (match) {
        return {
          scale: parseFloat(match[1]),
          offsetX: parseFloat(match[2]),
          offsetY: parseFloat(match[3]),
        };
      }

      return { scale: 1, offsetX: 0, offsetY: 0 };
    },
    getScaleFromObject(obj) {
      // Ensure the object has the necessary property
      if (!obj || !obj.img || typeof obj.img.transform !== 'string') {
        console.error('Invalid object structure. Expected object.img.transform to be a string.');
        return null;
      }

      const transformString = obj.img.transform;
      const match = transformString.match(/scale\(([^)]+)\)/);
      return match ? parseFloat(match[1]) : null;
    },
    async removeBlackBorders(base64Image) {
      

      // Create Image from Base64
      const img = new Image();
      img.src = base64Image;

      await new Promise((resolve) => (img.onload = resolve));

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, img.width, img.height);
      const { data, width, height } = imageData;

      let top = 0,
        left = 0,
        right = width,
        bottom = height;

      // Detect top boundary
      outer: for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const idx = (y * width + x) * 4;
          if (data[idx] !== 0 || data[idx + 1] !== 0 || data[idx + 2] !== 0 || data[idx + 3] !== 0) {
            top = y;
            break outer;
          }
        }
      }

      // Detect bottom boundary
      outer: for (let y = height - 1; y >= 0; y--) {
        for (let x = 0; x < width; x++) {
          const idx = (y * width + x) * 4;
          if (data[idx] !== 0 || data[idx + 1] !== 0 || data[idx + 2] !== 0 || data[idx + 3] !== 0) {
            bottom = y + 1;
            break outer;
          }
        }
      }

      // Detect left boundary
      outer: for (let x = 0; x < width; x++) {
        for (let y = 0; y < height; y++) {
          const idx = (y * width + x) * 4;
          if (data[idx] !== 0 || data[idx + 1] !== 0 || data[idx + 2] !== 0 || data[idx + 3] !== 0) {
            left = x;
            break outer;
          }
        }
      }

      // Detect right boundary
      outer: for (let x = width - 1; x >= 0; x--) {
        for (let y = 0; y < height; y++) {
          const idx = (y * width + x) * 4;
          if (data[idx] !== 0 || data[idx + 1] !== 0 || data[idx + 2] !== 0 || data[idx + 3] !== 0) {
            right = x + 1;
            break outer;
          }
        }
      }

      const newWidth = right - left;
      const newHeight = bottom - top;

      if (newWidth <= 0 || newHeight <= 0) {
        console.warn("No non-black area found.");
        return null;
      }

      // Create a new canvas for the trimmed image
      const trimmedCanvas = document.createElement("canvas");
      trimmedCanvas.width = newWidth;
      trimmedCanvas.height = newHeight;
      const trimmedCtx = trimmedCanvas.getContext("2d");

      trimmedCtx.putImageData(ctx.getImageData(left, top, newWidth, newHeight), 0, 0);

      // Convert to Base64
      const trimmedBase64 = trimmedCanvas.toDataURL();

      return { trimmedBase64, newWidth, newHeight };
    },

    
    async onNewImage() {
      // this.sliderVal = Number(this.aspectRatio);
      // this.sliderMin = Number(this.aspectRatio);
      // this.sliderMax = Number(this.aspectRatio) * 8;
      this.sliderVal = 1;
      this.sliderMin = 1;
      this.sliderMax = 8;

      this.isCloseOnly = true

      const maxWidth = 500;
      const maxHeight = 400;

      let width = this.imageWidth;
      let height = this.imageHeight;

      // Scale while maintaining aspect ratio
      const aspectRatio = width / height;

      if (width > maxWidth || height > maxHeight) {
        if (width / maxWidth > height / maxHeight) {
          width = maxWidth;
          height = Math.round(width / aspectRatio);
        } else {
          height = maxHeight;
          width = Math.round(height * aspectRatio);
        }
      }

      this.setImageWidth = width;
      this.setImageHeight = height;


      if (this.fileType === 'gif') {
        this.isLoading = true
        this.frames = await this.extractGifFrames(this.rawImageFile);
        this.originalFrames = await this.extractGifFrames(this.rawImageFile);
        this.cropperImage = this.frames[0].imageCanvas
        this.disableSlider = false
      } else { 
        this.cropperImage = this.initialValue
        this.disableSlider = false
        this.isLoading = false
      }
    },
    onSliderChange(evt) {
      const newScale = +evt.target.value; // Convert to number
      this.currentZoomValue = evt.target.value;
      const cropper = this.$refs.cropper;

      if (cropper) {
        const scaleDiff = newScale - this.lastScale; // Compute the difference

        cropper.changeScale(scaleDiff); // Adjust based on difference
        

        this.lastScale = newScale; // Update last scale value
      }
    },
    onZoom() {
      this.values.sliderVal = this.values.croppa.scaleRatio;
    },
    closeModal: function () {
      // this.$emit("clearImage");
      this.$root.$emit("bv::hide::modal", `UploadImageAnswer${this.componentKey}`);
      if (this.isCloseOnly) { 
      this.$emit("closeModal", {
                  key: this.imageKey,
                  showImage: true
                }); 
      }
      
      this.isCropping = false;
      this.isLoading = false;
      this.count = 0;
      this.resetData()
    },
    resetData() {
      this.lastScale = 1;
      this.sliderVal = 0;
      this.sliderMin = 0;
      this.sliderMax = 0;
      this.imageRawData = null;
      this.frames = [];
      this.encodedGif = null;
      this.isLoading = true;
      this.isCropping = false;
      this.setImageWidth = 500;
      this.setImageHeight = 400;
      this.currentImageHeight = 0;
      this.currentImageWidth = 0;
      this.isCloseOnly = true;
      this.setScale = 1;
      this.count = 0;
      this.cropData = {};
    },
    removeImage() {
      this.closeModal();
      this.$emit("clearImage");
      // this.$root.$emit("bv::hide::modal", `UploadImageAnswer${this.componentKey}`);
    },
    
    async checkFileType() {
      if (!this.imageRawData || (this.imageRawData.h*this.currentZoomValue === this.currentImageHeight && this.imageRawData.w*this.currentZoomValue === this.currentImageWidth)) {
        this.closeModal();
      } else {
      this.proceedCrop();
      }
      
    },
    async proceedCrop() { 
      this.isCloseOnly = false
      this.isCropping = true
      this.isLoading = true

      const cropAxis = this.$refs.cropper.getCropAxis()
      const imgAxis = this.$refs.cropper.getImgAxis()

      const realX = Math.abs(cropAxis.x1 - imgAxis.x1)
      const realY = Math.abs(cropAxis.y1 - imgAxis.y1)
      this.cropData = {
        height: cropAxis.y2 - cropAxis.y1, 
        width: cropAxis.x2 - cropAxis.x1, 
        x: realX, 
        y: realY  
      };

      if (this.fileType === 'gif') {
        await this.generateGif(false)
      } else { 
        await this.generateBase64()
        this.closeModal();
      }
    },
    async generateGif(download) { 
      this.$nextTick(() => {

         const croppedPromises = this.frames.map((frame, index) => {
          return this.cropBase64Image(frame.imageCanvas, frame.width, frame.height, this.imageRawData.img.transform)
            .then(croppedBase64 => {

              return this.removeBlackBorders(croppedBase64)
                .then(cleanBase64 => {
                  this.frames[index].width = cleanBase64.newWidth;
                  this.frames[index].height = cleanBase64.newHeight;
                  this.frames[index].imageCanvas = cleanBase64.trimmedBase64;
                })
                .catch(error => {
                  
                })
                
            })
            .catch(error => {
           
            });
        });



        Promise.all(croppedPromises).then(() => {
          this.createGif(this.frames,download);
        });
      });
    },
    getImageDimensionsFromBase64(base64String) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
    img.src = base64String; // Directly use the full base64 string with the prefix (data:image/*)
  });
},
    async generateBase64() {
      this.$refs.cropper.getCropData(data => {
        // base64

        const prefix = data.match(/^data:image\/\w+;base64,/)[0]; // Extract prefix
        const base64String = data.replace(prefix, ""); // Remove prefix from data

        this.$emit("newImageData", {
          key: this.imageKey,
          prefix: prefix,
          base64: base64String,
          image: data,
          showImage: true
        });
      })
    },
    checkFile: function (rawdata) {
      this.imageRawData = rawdata;
      console.log(rawdata,"rawdata")
      this.count++;
      if (this.count === 3) { 
        this.currentImageHeight = rawdata.h
        this.currentImageWidth = rawdata.w
        
      }
      
      this.setScale = this.getScaleFromObject(rawdata) + Number((1 - (rawdata.w / Math.round(Number(rawdata.img.width.replace("px", ""))))).toFixed(1))
    },
    async checkDownloadFile() { 
      const cropAxis = this.$refs.cropper.getCropAxis()
      const imgAxis = this.$refs.cropper.getImgAxis()

      const realX = Math.abs(cropAxis.x1 - imgAxis.x1)
      const realY = Math.abs(cropAxis.y1 - imgAxis.y1)
      this.cropData = {
        height: cropAxis.y2 - cropAxis.y1, 
        width: cropAxis.x2 - cropAxis.x1, 
        x: realX, 
        y: realY  
      };
      if (this.fileType === 'gif') {
        await this.generateGif(true)
      } else { 
        await this.downloadCroppedImage()
      }
    },
    async downloadCroppedImage() {
      this.$refs.cropper.getCropBlob((blob) => {
        if (!blob) {
          return;
        }

        const aLink = document.createElement("a");
        const blobUrl = window.URL.createObjectURL(blob);

        // Set the file extension dynamically based on this.fileType
        const extension = this.fileType === 'jpeg' ? '.jpg' :
          this.fileType === 'png' ? '.png' :
            this.fileType === 'gif' ? '.gif' : '.png';

        aLink.href = blobUrl;
        aLink.download = `${this.fileName}-cropped${extension}`;

        this.downImg = blobUrl;
        aLink.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      }, this.fileType);
    }
  }
};
</script>

<style scoped>
.spinner {
    animation: rotate 1.5s linear infinite;
    /* Add rotation animation */
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
        /* Start rotation from 0 degrees */
    }

    to {
        transform: rotate(360deg);
        /* Rotate 360 degrees (full circle) */
    }
}

.small {
    width: 15px;
    height: 15px;
}

</style>